import {combineReducers} from 'redux';
import entity from './entity';
import order from './order';
import trip from './trip';
import region from './region';
import city from './city';
import poi from './poi';
import route from './route';
import trafficRules from './trafficRules';
import ticket from './ticket';
import {actionType, PERSISTENT_STATE_KEYS} from '../localState';
import deepSet from '../../utils/deepSet';
import deepGet from '../../utils/deepGet';

const reducer = combineReducers({
  // 所有数据实体（对应数据表）
  entity,
  // 订单相关数据（一般只保存 id）
  order,
  // 行程接口相关数据
  trip,
  // 地区
  region,
  // 城市
  city,
  // poi相关
  poi,
  // 路线相关
  route,
  // 交规
  trafficRules,
  // 门票
  ticket
});

export default function (state = {}, action) {
  if (action.type === actionType) {
    let nextState = {...state};
    let localState = action.data;
    PERSISTENT_STATE_KEYS.forEach(function (key) {
      deepSet(nextState, key, deepGet(localState, key));
    });

    return reducer(nextState, action);
  }

  return reducer(state, action);
}



// WEBPACK FOOTER //
// ./src/store/reducers/index.js